/**
 * @generated SignedSource<<6df9d103a5ac1f082da222a27d75f0ed>>
 * @relayHash 74bceb2880e4acba1f6c57632a1e84c8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5e45583d3d0b67511dc2134859fd0de8080362edff9066b36aeb825b06b4fb43

import type { ConcreteRequest, Query } from 'relay-runtime';
export type endUserRequestModalQuery$variables = Record<PropertyKey, never>;
export type endUserRequestModalQuery$data = {
  readonly userPreferences: {
    readonly onboardingState: ReadonlyArray<{
      readonly key: string;
      readonly value: string | null | undefined;
    }>;
  } | null | undefined;
};
export type endUserRequestModalQuery = {
  response: endUserRequestModalQuery$data;
  variables: endUserRequestModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "userPreferences",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Literal",
            "name": "key",
            "value": "end-user-request-to-upgrade-latest-timestamp"
          }
        ],
        "concreteType": "UserOnboardingState",
        "kind": "LinkedField",
        "name": "onboardingState",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "value"
          }
        ],
        "storageKey": "onboardingState(key:\"end-user-request-to-upgrade-latest-timestamp\")"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "endUserRequestModalQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "endUserRequestModalQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "5e45583d3d0b67511dc2134859fd0de8080362edff9066b36aeb825b06b4fb43",
    "metadata": {},
    "name": "endUserRequestModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "85c8714a4bf9b70c2bf50e70a13c257f";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
